// dependencies
import React from "react";

// styles
import styles from "./css/PrimaryBtn.module.css";

export default function PrimaryBtn({ text, onClick, small=false}) {
    return (
        // background
        <button className={styles.btn} onClick={onClick}>
            {text}
        </button>
    );
}
